export class CategoryData {
  constructor(
    public name: string = '',
    public count: number = 0,
    public color: string
  ) {}
}